import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { AsideNavService } from './aside-nav.service';
import { Helpers } from '../../../helpers';

declare let mLayout: any;
@Component({
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
    providers: [
        AsideNavService
    ],
})
export class AsideNavComponent implements OnInit, AfterViewInit {

    pendingCount: any = 0;
    isFeedbackPendingCount: any = false;
    userDetails: any = sessionStorage.getItem('userDetails');
    menuItems: any;
    environment: string;
    constructor(
        private _navService: AsideNavService) {
    }
    ngOnInit() {


    }

    ngAfterViewInit() {

        mLayout.initAside();

    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/aside-nav/aside-nav.component.ts